import { useTheme, useMediaQuery } from "@mui/material";

const useResponsive = () => {
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // < 600px
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md")); // 600px - 900px
  const isLaptop = useMediaQuery(theme.breakpoints.between("md", "lg")); // 900px - 1200px
  const isDesktop = useMediaQuery(theme.breakpoints.up("lg")); // > 1200px
  const isExtraLarge = useMediaQuery(theme.breakpoints.up("xl")); // > 1536px

  // Helpers for common ranges
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));
  const isDesktopOrLarger = useMediaQuery(theme.breakpoints.up("lg"));

  // Backwards compatibility aliases used in other files
  const isSmallScreen = isMobileOrTablet; // < 900px
  const isExtraSmall = isMobile; // < 600px

  return {
    isMobile,
    isTablet,
    isLaptop,
    isDesktop,
    isExtraLarge,
    isMobileOrTablet,
    isDesktopOrLarger,
    isSmallScreen,
    isExtraSmall,
    // String identifier for the current breakpoint
    breakpoint: isExtraLarge
      ? "xl"
      : isDesktop
        ? "lg"
        : isLaptop
          ? "md"
          : isTablet
            ? "sm"
            : "xs",
  };
};

export default useResponsive;
